import { createContext } from "react"

export interface ExpenseInterface {
  _id: any,
  note: string,
  amount: string,
  createdAt: string,
  updatedAt: string,
}

export const DefaultExpenseInterface: ExpenseInterface = {
  _id: "",
  note: "",
  amount: "",
  createdAt: "",
  updatedAt: "",
}

export interface ShowExpenseInterface {
  showSuccessMsg: boolean,
  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showEditModal: boolean,
  setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean,
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedExpense: ExpenseInterface,
  setSelectedExpense: (selectedExpense: ExpenseInterface) => void,
  day: number,
  setDay: (day: number) => void,
  month: number,
  setMonth: (month: number) => void,
  year: number,
  setYear: (year: number) => void,
  showSwitchDate: boolean,
  setShowSwitchDate: (showSwitchDate: boolean) => void,
  startDate: Date,
  setStartDate: (startDate: Date) => void,
  endDate: Date,
  setEndDate: (endDate: Date) => void,
  selectedDate: Date,
  setSelectedDate: (selectedDate: Date) => void,
}

export const  DefaultShowExpenseInterface: ShowExpenseInterface = {
  showSuccessMsg: false,
  setShowSuccessMsg: () => {},
  showEditModal: false,
  setShowEditModal: () => {},
  showDeleteModal: false,
  setShowDeleteModal: () => {},
  selectedExpense: DefaultExpenseInterface,
  setSelectedExpense: () => {},
  day: 0,
  setDay: () => {},
  month: 0,
  setMonth: () => {},
  year: 0,
  setYear: () => {},
  showSwitchDate: false,
  setShowSwitchDate: () => {},
  startDate: new Date(),
  setStartDate: () => {},
  endDate: new Date(),
  setEndDate: () => {}, 
  selectedDate: new Date(),
  setSelectedDate: () => {},
}

export const ShowExpenseContext = createContext(DefaultShowExpenseInterface)

export interface DataExpenseInterface {
  note: string,
  setNote: (note: string) => void, 
  amount: string,
  setAmount: (amount: string) => void,
  createdAt: string,
  setCreatedAt: (createdAt: string) => void,
}

export const DefaultDataExpenseInterface: DataExpenseInterface = {
  note: "",
  setNote: () => {}, 
  amount: "",
  setAmount: () => {},
  createdAt: "",
  setCreatedAt: () => {},
}

export const DataExpenseContext = createContext(DefaultDataExpenseInterface)


